import { fromFetch } from 'rxjs/fetch';
import { z } from 'zod/v4';

import { requiredHeaders } from '../../../models/required-headers';
import { selectData } from '../../../utils/select-data';
import { withJwt } from '../../../utils/with-jwt';
import { miEnvironment } from '../mobile-instructions-environment';
import { SearchRequest } from '../models/search-request';
import { instructionV2ResponseSchema } from '../schemas/instruction-v2-response.schema';

/**
 * Searches for instructions based on passed in parameters using the v2 API
 * that includes vehicle group names in the response
 * @param searchRequest The parameters specifying which instructions to search for
 * @returns The searched for instructions with vehicle group details
 */
export function postInstructionV2Search(
  this: unknown,
  searchRequest: Partial<SearchRequest>
) {
  return withJwt((jwtAuthHeaders) =>
    fromFetch(
      new Request(miEnvironment.resolve(this).instructionV2SearchUrl, {
        method: 'POST',
        headers: {
          ...requiredHeaders,
          ...jwtAuthHeaders,
        },
        body: JSON.stringify(searchRequest),
      })
    )
  ).pipe(selectData(z.array(instructionV2ResponseSchema)));
}
